import {qspost, qspostfile} from '@/plugins/axios'

/*
 * 房屋信息列表
 * @constructor jack
 * */
export const roomList = (searchXiangMuId, searchSheQuId, searchLouId, searchMenId, searchHuId, searchFangWuXingZhi, searchJuZhuQingKuang, page, pageSize) => qspost('/Index/Room/roomList', {
  searchXiangMuId,
  searchSheQuId,
  searchLouId,
  searchMenId,
  searchHuId,
  searchFangWuXingZhi,
  searchJuZhuQingKuang,
  page,
  pageSize
})

/*
 * 获取绑定设备的房屋
 * */
export const roomDevList = (xiangmu_id,xiaoqu_id,lou_id,men_id,hu_id,page,pageSize) => qspost('/Index/Device/getRoomList', {
  xiangmu_id,xiaoqu_id,lou_id,men_id,hu_id,page,pageSize})



/*
 * 房屋信息列表
 * @constructor jack
 * */
export const newRoomList = (searchXiangMuId, searchSheQuId, searchLouId, searchMenId, searchHuId, searchFangWuXingZhi, searchJuZhuQingKuang,searchStatus, page, pageSize) => qspost('/Index/Room/newRoomList', {
  searchXiangMuId,
  searchSheQuId,
  searchLouId,
  searchMenId,
  searchHuId,
  searchFangWuXingZhi,
  searchJuZhuQingKuang,
  searchStatus,
  page,
  pageSize
})

/*
 * 居民信息详情
 * @constructor jack
 * */
export const roomUpdate = (xingZhi, mianJi, juZhuQingKuang, zongGai, wuYeHeTong, beizhu, roomId) => qspost('/Index/Room/roomUpdate', {
  xingZhi,
  mianJi,
  juZhuQingKuang,
  zongGai,
  wuYeHeTong,
  beizhu,
  roomId
})


/*
 * 导出房间信息
 * @constructor jack
 * */
export const exportRoomListToUpdate = (xiangMuId, xiaoQuId) => qspostfile('/Index/Export/exportRoomListToUpdate', {
  xiangMuId, xiaoQuId
})



/*
 * 获取绑定设备的房屋详情
 * */
export const getRoomDetails = (room_id) => qspost('/Index/Device/getRoomDetails', {room_id})

/*
 * 获取绑定设备
 * */
export const getRoomDeviceList = (room_id) => qspost('/Index/Device/getRoomDeviceList', {room_id})

/*
 * 获取绑定设备
 * */
export const bdingDevice = (id,room_id,name,dev_id,type) => qspost('/Index/Device/bdingDevice', {id,room_id,name,dev_id,type})

/*
 * 设备解绑
 * */
export const delRoomDevice = (id) => qspost('/Index/Device/delRoomDevice', {id})

/*
 * 修改房屋绑定的紧急联系人、物业管家，专业人员
 * */
export const updateDeviceRoomDetail1 = (room_id,admin_id) => qspost('/Index/Device/updateDeviceRoomDetail', {room_id,admin_id})

/*
 * 修改房屋绑定的紧急联系人、物业管家，专业人员
 * */
export const updateDeviceRoomDetail2 = (room_id,exclusive_personnel_id) => qspost('/Index/Device/updateDeviceRoomDetail', {room_id,exclusive_personnel_id})

/*
 * 修改房屋绑定的紧急联系人、物业管家，专业人员
 * */
export const updateDeviceRoomDetail3 = (room_id,emergency_contact) => qspost('/Index/Device/updateDeviceRoomDetail', {room_id,emergency_contact})
